import React, { VFC } from 'react';
import { TooltippedButtonWrapper, TooltippedButtonWrapperProps } from '@tanium/react-button-base';
import { Button } from './Button';
import { ButtonProps } from './types';

export interface TooltippedButtonProps
  extends ButtonProps,
    Pick<
      TooltippedButtonWrapperProps,
      'tooltipContent' | 'tooltipModifiers' | 'tooltipPlacement'
    > {}

const TooltippedButtonInner = React.forwardRef<HTMLElement, TooltippedButtonProps>(
  ({ tooltipContent, tooltipModifiers, tooltipPlacement, ...props }, forwardedRef) => (
    <TooltippedButtonWrapper
      tooltipContent={tooltipContent}
      tooltipModifiers={tooltipModifiers}
      tooltipPlacement={tooltipPlacement}
      disabled={props.disabled}
    >
      <Button {...props} ref={forwardedRef} />
    </TooltippedButtonWrapper>
  ),
);

TooltippedButtonInner.displayName = 'TooltippedButton';

// This type cast provides better typings and Intellisense for consumers
export const TooltippedButton = TooltippedButtonInner as VFC<
  TooltippedButtonProps & { ref?: React.Ref<HTMLElement> }
>;
